namespace Matrix.Data {
    export class AccountColumns {
        static columnsKey = 'Data.Account';
    }
}
